import React, { ReactElement } from "react";
import "./index.less";

export interface SettingMicLevelProps {
    micLevel: number;
    className: string;
    width?: string;
}

export const SettingMicLevel: React.FC<SettingMicLevelProps> = ({
    className,
    micLevel,
    width = "100%",
}): ReactElement => {
    return (
        <div className={`MicLevel ${className ? className : ""}`}>
            <svg height="20" width={width}>
                <defs>
                    <pattern height="20" id="bgStripes" patternUnits="userSpaceOnUse" width="10">
                        <rect fill="#3b3c40" height="20" rx="2" ry="2" width="5" x="0" />
                    </pattern>
                    <linearGradient id="fgGradient" x1="0%" x2="100%" y1="0%" y2="0%">
                        <stop offset="0%" stopColor="#744CF6" />
                        <stop offset="100%" stopColor="#5333D5" />
                    </linearGradient>
                    <pattern height="20" id="fgStripes" patternUnits="userSpaceOnUse" width="10">
                        <rect fill="url(#fgGradient)" height="20" rx="2" ry="2" width="5" x="0" />
                    </pattern>
                    <pattern
                        height="20"
                        id="stripePattern"
                        patternUnits="userSpaceOnUse"
                        width="10"
                    >
                        <rect fill="white" height="20" rx="2" ry="2" width="5" x="0" y="0" />
                    </pattern>

                    <mask id="stripesMask">
                        <rect fill="url(#stripePattern)" height="20" width="100%" />
                    </mask>
                </defs>
                <rect fill="url(#bgStripes)" height="20" width="100%" />
                <rect
                    fill="url(#fgGradient)"
                    height="20"
                    mask="url(#stripesMask)"
                    width={`${micLevel}%`}
                />
            </svg>
        </div>
    );
};
